import {Swiper} from 'vue-awesome-swiper';

export default Swiper;
